import { Component, OnInit } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { constants } from '../../../../shared/constants/constants';
@Component({
  selector: 'app-notifications-modal',
  standalone: true,
  imports: [ButtonModule, RadioButtonModule, DynamicDialogModule],
  templateUrl: './notifications-modal.component.html',
  styleUrl: './notifications-modal.component.scss'
})
export class NotificationsModalComponent implements OnInit {
  messageInfo: any = {
    message: '',
    approveDenyMessage: '',
    messageFrom: ''
  };
  constructor(private quitPositionModalRef: DynamicDialogRef, public config: DynamicDialogConfig) { }
  
  ngOnInit(): void {
    this.messageInfo = this.config.data;
  }

  confirm(isConfirm: boolean) {
    this.quitPositionModalRef.close(isConfirm);
  }
}
